export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      product: 'Products',
      contact: 'Contact',
    },
    hero: {
      brand: 'Lithioo Perfumes',
      buttonShop: 'Shop collection',
      slides: [
        {
          line1: 'At Lithioo Perfume, we believe that fragrance is more than just a scent.',
          line2: '',
        },
        {
          line1: "It's an identity... a feeling... a lasting memory...",
          line2: '',
        },
        {
          line1: 'Carefully crafted to express you.',
          line2: '',
        },
      ],
    },
    collection: {
      title: 'Our New Collection',
      description:
        'Discover our latest fragrances — curated picks to help you find your next signature scent.',
    },
    whyChoose: {
      title: 'Why Choose Us',
      description:
        'At Lithioo Perfumes, we craft unforgettable scents with care and passion. Every bottle reflects our commitment to luxury, authenticity, and your satisfaction.',
      features: {
        quality: 'Excellent Quality',
        qualityDesc: 'Premium blends with long-lasting projection you can trust.',
        ingredients: 'Luxury Ingredients',
        ingredientsDesc: 'Fine oils and notes selected for richness and elegance.',
        experience: 'Years of Expertise',
        experienceDesc: 'Trusted knowledge in perfumes to guide your perfect choice.',
      },
    },
    store: {
      title: 'Our Store',
      subtitle: "Browse our collections — men's, women's, and oriental fragrances",
      productsCount: 'products',
      noProducts: 'No products in this section.',
      viewAll: 'View all',
      fullCatalog: 'Full catalog',
    },
    sections: {
      men: 'Men Section',
      women: 'Women Section',
      special: 'Oriental Section',
      'new-diverse': 'Divers',
      original: 'Original Section',
    },
    productsPage: {
      title: 'Our Products',
      subtitle: 'Choose a collection and explore our luxury fragrances',
      noProducts: 'No products in this section yet.',
    },
    header: {
      allProducts: 'All products',
      productsShort: 'Products',
      brandsShort: 'Brands',
      brandsTitle: 'Browse brands',
      brandsEmpty: 'No brands available yet.',
      searchShort: 'Search',
      wishlistShort: 'Favorites',
      cartShort: 'Cart',
      productsTitle: 'Browse products',
      searchTitle: 'Search products',
      searchPlaceholder: 'Search by name, brand, or category',
      searchHint: 'Type a word to find a fragrance quickly.',
      searchNoResults: 'No matching products found.',
      wishlistTitle: 'Saved products',
      wishlistEmpty: 'Your wishlist is empty.',
      wishlistHint: 'Tap the heart on any product to save it here.',
      clearWishlist: 'Clear wishlist',
      browseCatalog: 'Browse catalog',
      removeWishlistItem: 'Remove from wishlist',
    },
    modal: {
      brand: 'Lithioo Perfume',
      reviews: 'reviews',
      productDetails: 'Product details',
      ingredients: 'Ingredients / Notes',
      benefits: 'How you benefit',
      type: 'Type',
      typeValue: 'Eau de Parfum',
      availability: 'Availability',
      inStock: 'In stock',
      outOfStock: 'Out of stock',
      orderNow: 'Order Now',
      addToCart: 'Add to cart',
      wishlist: 'Wishlist',
      saved: 'Saved',
      viewFull: 'View full product page →',
      close: 'Close',
    },
    cart: {
      added: 'Added to cart',
      title: 'Shopping Cart',
      empty: 'Your cart is empty',
      continueShopping: 'Continue Shopping',
      total: 'Total',
      clearCart: 'Clear Cart',
      viewCart: 'View Cart',
      orderNow: 'Order Now',
      close: 'Close cart',
      decreaseQty: 'Decrease quantity',
      increaseQty: 'Increase quantity',
      removeItem: 'Remove item',
      notesTitle: 'Order notes',
      notesLabel: 'Notes (optional)',
      notesPlaceholder: 'Add any notes about your order, delivery address, or special requests…',
      notesHint: 'These notes will be sent with your order on WhatsApp.',
    },
    newsletter: {
      title: 'GET OUR NEWSLETTER',
      placeholder: 'Your email',
      button: 'Subscribe',
      success: 'Thank you for subscribing!',
    },
    testimonials: {
      title: 'What Our Customers Say',
      subtitle: 'Real reviews from our happy customers — thank you for trusting Lithioo Perfumes.',
    },
    aboutPage: {
      title: 'About Lithioo',
      subtitle:
        'Where luxury meets character — crafted fragrances for men, women, and those who love oriental scents.',
      storyTitle: 'Our Story',
      story:
        'Lithioo For Perfumes was built on a simple belief: everyone deserves a signature scent that feels personal and lasts.',
      missionTitle: 'What We Stand For',
      mission:
        'Quality ingredients, honest pricing, and attentive service — whether you shop online or visit us in Beni Suef.',
      cta: 'Shop the Collection',
      ctaTitle: 'Ready to find your scent?',
      ctaText: "Browse our full catalog — men's, women's, and oriental fragrances in every size.",
      values: [
        {
          title: 'Authentic Quality',
          text: 'Every fragrance is selected for lasting projection and a refined finish.',
        },
        {
          title: 'Curated Selection',
          text: "Men's, women's, and oriental collections — something for every taste.",
        },
        {
          title: 'Customer First',
          text: 'Personal guidance and flexible sizes so you shop with confidence.',
        },
      ],
      highlights: [
        { value: '114+', label: 'Fragrances' },
        { value: '4', label: 'Collections' },
        { value: '3', label: 'Bottle Sizes' },
      ],
    },
    contactPage: {
      title: 'Contact Us',
      subtitle: 'Questions about a scent, an order, or our store? Reach out — we are happy to help.',
      form: {
        name: 'Your Name',
        email: 'Your Email',
        message: 'Your Message',
        submit: 'Send Message',
        success: 'Thank you! Your email app will open to send your message.',
      },
      visitTitle: 'Visit Our Store',
      followTitle: 'Follow Us',
      whatsappCta: 'Chat on WhatsApp',
      mapCta: 'Open in Maps',
      sendMessage: 'Send a Message',
      formHint: 'Fill in the form and we will open your email app to send your message to us.',
      phone: 'Phone',
      whatsapp: 'WhatsApp',
      email: 'Email',
      followFacebook: 'Follow Lithioo on Facebook',
    },
    newLuxury: {
      title: 'New Luxury Products',
      subtitle: 'A handpicked selection of our latest luxury arrivals',
      prev: 'Previous',
      next: 'Next',
      orderNow: 'Order on WhatsApp',
      newTag: 'New',
    },
    newDiverse: {
      title: 'Divers Products',
      subtitle: 'Explore our latest collection of diverse and distinctive fragrances',
      prev: 'Previous',
      next: 'Next',
      orderNow: 'Order on WhatsApp',
      newTag: 'New',
    },
    originals: {
      title: 'Original Perfumes',
      subtitle: '100% authentic designer and niche perfumes in original packaging',
      viewAll: 'View all originals',
    },
    luxury: {
      title: 'Our Featured Brands',
      subtitle: 'Explore exclusive collections from premier fragrance houses',
      discover: 'Discover Now',
      enter: 'Enter',
    },
    brands: {
      title: 'Our Brands',
      subtitle: 'Trusted fragrance houses and luxury partners from around the world',
      price: 'Price',
    },
    footer: {
      tagline: 'Premium fragrances crafted with care. Discover your signature scent at Lithioo.',
      quickLinks: 'Quick Links',
      getInTouch: 'Get in Touch',
      whatsappLine: 'WhatsApp — {phone}',
      followUs: 'Follow us',
      rights: 'All Rights Reserved',
      catalog: 'Catalog',
      facebook: 'Facebook',
      instagram: 'Instagram',
      whatsapp: 'WhatsApp',
      callUs: 'Call us',
      emailUs: 'Email us',
      viewMap: 'View location on map',
    },
    cartPage: {
      emptyHint: "Looks like you haven't added anything to your cart yet.",
      back: 'Back',
      orderSummary: 'Order Summary',
      subtotal: 'Subtotal',
      shipping: 'Shipping',
      free: 'Free',
      itemsOne: '1 item in your cart',
      itemsMany: '{count} items in your cart',
    },
    productPage: {
      back: 'Back',
      quantity: 'Quantity',
      category: 'Category',
      added: 'Added!',
      inWishlist: 'In Wishlist',
      addToWishlist: 'Add to Wishlist',
      addToCart: 'Add to Cart',
    },
    productCard: {
      orderWhatsApp: 'Order on WhatsApp',
      addToCart: 'Add to cart',
      viewDetails: 'View details',
    },
    floating: {
      quickContact: 'Quick contact',
      closeMenu: 'Close contact menu',
      openMenu: 'Open contact menu',
      close: 'Close',
      whatsapp: 'WhatsApp',
      call: 'Call',
      facebook: 'Facebook',
      instagram: 'Instagram',
      email: 'Email',
    },
    address: {
      area: 'Al-Abasiry, Beni Suef',
      street: 'Chanel St., off Abdelsalam Aref St., next to Dona Dony dealership',
    },
    whatsapp: {
      greeting: 'Hello! I would like to know more about Lithioo Perfumes products.',
      cartIntro: 'Hello! I would like to place an order from Lithioo Perfumes:',
      singleIntro: 'Hello! I would like to order from Lithioo Perfumes:',
      product: 'Product',
      brand: 'Brand',
      size: 'Size',
      price: 'Price',
      category: 'Category',
      total: 'Total',
      notes: 'Notes',
      thankYou: 'Thank you!',
      confirmDelivery: 'Please confirm availability and delivery. Thank you!',
    },
    a11y: {
      languageAr: 'Arabic',
      languageEn: 'English',
      switchLanguage: 'Switch language',
      toggleTheme: 'Toggle theme',
      productSections: 'Product sections',
      shoppingCart: 'Shopping cart',
      toggleMenu: 'Toggle menu',
      closeMenu: 'Close menu',
      mobileProducts: 'Open products menu',
      mobileSearch: 'Search products',
      mobileWishlist: 'Open wishlist',
      mobileCart: 'Open cart',
      bottleSize: 'Bottle size',
      hero: 'Hero',
      prevSlide: 'Previous slide',
      nextSlide: 'Next slide',
      prevPage: 'Previous page',
      nextPage: 'Next page',
    },
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      about: 'من نحن',
      product: 'المنتجات',
      contact: 'اتصل بنا',
    },
    hero: {
      brand: 'ليثيو للعطور',
      buttonShop: 'تسوق المجموعة',
      slides: [
        {
          line1: 'في ليثيو للعطور، نؤمن أن العطر أكثر من مجرد رائحة.',
          line2: '',
        },
        {
          line1: 'إنه هوية... إحساس... ذكرى تدوم...',
          line2: '',
        },
        {
          line1: 'مصنوع بعناية ليعبّر عنك.',
          line2: '',
        },
      ],
    },
    collection: {
      title: 'مجموعتنا الجديدة',
      description: 'اكتشف أحدث عطورنا — اختيارات مختارة لمساعدتك في إيجاد عطرك المميز.',
    },
    whyChoose: {
      title: 'لماذا تختارنا',
      description:
        'في ليثيو للعطور، نصنع روائح لا تُنسى بعناية وشغف. كل زجاجة تعكس التزامنا بالفخامة والأصالة ورضاك.',
      features: {
        quality: 'جودة ممتازة',
        qualityDesc: 'خلطات فاخرة بثبات عالٍ يمكنك الوثوق به.',
        ingredients: 'مكونات فاخرة',
        ingredientsDesc: 'زيوت ونوتات مختارة بعناية للثراء والأناقة.',
        experience: 'سنوات من الخبرة',
        experienceDesc: 'معرفة موثوقة بالعطور لمساعدتك في اختيارك المثالي.',
      },
    },
    store: {
      title: 'متجرنا',
      subtitle: 'تصفح مجموعاتنا — عطور رجالية ونسائية وشرقية',
      productsCount: 'منتج',
      noProducts: 'لا توجد منتجات في هذا القسم.',
      viewAll: 'عرض الكل',
      fullCatalog: 'الكتالوج الكامل',
    },
    sections: {
      men: 'قسم الرجال',
      women: 'قسم النساء',
      special: 'القسم الشرقي',
      'new-diverse': 'منتجات متنوعة',
      original: 'المنتجات الأصلية',
    },
    productsPage: {
      title: 'منتجاتنا',
      subtitle: 'اختر مجموعة واستكشف عطورنا الفاخرة',
      noProducts: 'لا توجد منتجات في هذا القسم بعد.',
    },
    header: {
      allProducts: 'الكل',
      productsShort: 'المنتجات',
      brandsShort: 'البراندات',
      brandsTitle: 'تصفح البراندات',
      brandsEmpty: 'لا توجد براندات متاحة بعد.',
      searchShort: 'بحث',
      wishlistShort: 'المفضلة',
      cartShort: 'السلة',
      productsTitle: 'تصفح المنتجات',
      searchTitle: 'ابحث عن منتج',
      searchPlaceholder: 'ابحث بالاسم أو العلامة أو الفئة',
      searchHint: 'اكتب كلمة للعثور على العطر بسرعة.',
      searchNoResults: 'لا توجد منتجات مطابقة.',
      wishlistTitle: 'المنتجات المحفوظة',
      wishlistEmpty: 'المفضلة فارغة.',
      wishlistHint: 'اضغط على القلب في أي منتج لحفظه هنا.',
      clearWishlist: 'مسح المفضلة',
      browseCatalog: 'تصفح الكتالوج',
      removeWishlistItem: 'إزالة من المفضلة',
    },
    modal: {
      brand: 'ليثيو للعطور',
      reviews: 'تقييم',
      productDetails: 'تفاصيل المنتج',
      ingredients: 'المكونات / النوتات',
      benefits: 'الفوائد',
      type: 'النوع',
      typeValue: 'او دي بارفان',
      availability: 'التوفر',
      inStock: 'متوفر',
      outOfStock: 'غير متوفر',
      orderNow: 'اطلب الآن',
      addToCart: 'أضف للسلة',
      wishlist: 'المفضلة',
      saved: 'محفوظ',
      viewFull: 'عرض صفحة المنتج الكاملة ←',
      close: 'إغلاق',
    },
    cart: {
      added: 'تمت الإضافة إلى السلة',
      title: 'سلة التسوق',
      empty: 'سلة التسوق فارغة',
      continueShopping: 'متابعة التسوق',
      total: 'الإجمالي',
      clearCart: 'إفراغ السلة',
      viewCart: 'عرض السلة',
      orderNow: 'اطلب الآن',
      close: 'إغلاق السلة',
      decreaseQty: 'تقليل الكمية',
      increaseQty: 'زيادة الكمية',
      removeItem: 'حذف المنتج',
      notesTitle: 'ملاحظات الطلب',
      notesLabel: 'ملاحظات (اختياري)',
      notesPlaceholder: 'أضف أي ملاحظات عن طلبك، عنوان التوصيل، أو طلبات خاصة…',
      notesHint: 'سيتم إرسال هذه الملاحظات مع طلبك عبر واتساب.',
    },
    newsletter: {
      title: 'اشترك في نشرتنا',
      placeholder: 'بريدك الإلكتروني',
      button: 'اشتراك',
      success: 'شكراً لاشتراكك!',
    },
    testimonials: {
      title: 'ماذا يقول عملاؤنا',
      subtitle: 'مراجعات حقيقية من عملائنا — شكراً لثقتكم بليثيو للعطور.',
    },
    aboutPage: {
      title: 'عن ليثيو',
      subtitle: 'حيث تلتقي الفخامة بالشخصية — عطور مصنوعة للرجال والنساء ومحبي العطور الشرقية.',
      storyTitle: 'قصتنا',
      story: 'تأسس ليثيو للعطور على إيمان بسيط: الجميع يستحق عطراً مميزاً يدوم.',
      missionTitle: 'ما نؤمن به',
      mission: 'مكونات عالية الجودة، أسعار عادلة، وخدمة متميزة — سواء تسوقت أونلاين أو زرتنا في بني سويف.',
      cta: 'تسوق المجموعة',
      ctaTitle: 'جاهز لاكتشاف عطرك المميز؟',
      ctaText: 'تصفّح تشكيلتنا الكاملة — عطور رجالية ونسائية وشرقية بجميع الأحجام.',
      values: [
        {
          title: 'جودة أصلية',
          text: 'كل عطر مُختار بعناية لثبات قوي ولمسة نهائية راقية.',
        },
        {
          title: 'تشكيلة مختارة',
          text: 'مجموعات رجالية ونسائية وشرقية — ما يناسب كل ذوق.',
        },
        {
          title: 'العميل أولاً',
          text: 'إرشاد شخصي وأحجام مرنة لتتسوق بثقة وراحة.',
        },
      ],
      highlights: [
        { value: '+114', label: 'عطر' },
        { value: '4', label: 'مجموعات' },
        { value: '3', label: 'أحجام' },
      ],
    },
    contactPage: {
      title: 'اتصل بنا',
      subtitle: 'أسئلة عن عطر أو طلب أو متجرنا؟ تواصل معنا — يسعدنا مساعدتك.',
      form: {
        name: 'اسمك',
        email: 'بريدك الإلكتروني',
        message: 'رسالتك',
        submit: 'إرسال الرسالة',
        success: 'شكراً! سيفتح تطبيق البريد لإرسال رسالتك.',
      },
      visitTitle: 'زر متجرنا',
      followTitle: 'تابعنا',
      whatsappCta: 'تواصل عبر واتساب',
      mapCta: 'افتح في الخرائط',
      sendMessage: 'أرسل رسالة',
      formHint: 'املأ النموذج وسنفتح تطبيق البريد لإرسال رسالتك إلينا.',
      phone: 'الهاتف',
      whatsapp: 'واتساب',
      email: 'البريد الإلكتروني',
      followFacebook: 'تابع ليثيو على فيسبوك',
    },
    newLuxury: {
      title: 'منتجات فاخرة جديدة',
      subtitle: 'تشكيلة مختارة بعناية من أحدث وصولاتنا الفاخرة',
      prev: 'السابق',
      next: 'التالي',
      orderNow: 'اطلب عبر واتساب',
      newTag: 'جديد',
    },
    newDiverse: {
      title: 'منتجات متنوعة',
      subtitle: 'اكتشف مجموعتنا الأحدث من العطور المتنوعة والمميزة',
      prev: 'السابق',
      next: 'التالي',
      orderNow: 'اطلب عبر واتساب',
      newTag: 'جديد',
    },
    originals: {
      title: 'العطور الأصلية',
      subtitle: 'عطور أصلية ومميزة من أرقى الماركات العالمية',
      viewAll: 'عرض كل الأصلية',
    },
    luxury: {
      title: 'أشهر دور العطور العالمية',
      subtitle: 'استكشف تشكيلات حصرية من أرقى بيوت العطور والماركات العالمية',
      discover: 'اكتشف الآن',
      enter: 'دخول',
    },
    brands: {
      title: 'شركاؤنا من الماركات العالمية',
      subtitle: 'علامات عطور موثوقة وشركاء فاخرون من مختلف أنحاء العالم',
      price: 'السعر',
    },
    footer: {
      tagline: 'عطور فاخرة مصنوعة بعناية. اكتشف عطرك المميز مع ليثيو.',
      quickLinks: 'روابط سريعة',
      getInTouch: 'تواصل معنا',
      whatsappLine: 'واتساب — {phone}',
      followUs: 'تابعنا',
      rights: 'جميع الحقوق محفوظة',
      catalog: 'الكتالوج',
      facebook: 'فيسبوك',
      instagram: 'إنستغرام',
      whatsapp: 'واتساب',
      callUs: 'اتصل بنا',
      emailUs: 'راسلنا بالبريد',
      viewMap: 'عرض الموقع على الخريطة',
    },
    cartPage: {
      emptyHint: 'يبدو أنك لم تضف أي منتجات إلى السلة بعد.',
      back: 'رجوع',
      orderSummary: 'ملخص الطلب',
      subtotal: 'المجموع الفرعي',
      shipping: 'الشحن',
      free: 'مجاني',
      itemsOne: 'منتج واحد في السلة',
      itemsMany: '{count} منتج في السلة',
    },
    productPage: {
      back: 'رجوع',
      quantity: 'الكمية',
      category: 'الفئة',
      added: 'تمت الإضافة!',
      inWishlist: 'في المفضلة',
      addToWishlist: 'أضف للمفضلة',
      addToCart: 'أضف للسلة',
    },
    productCard: {
      orderWhatsApp: 'اطلب عبر واتساب',
      addToCart: 'أضف للسلة',
      viewDetails: 'عرض التفاصيل',
    },
    floating: {
      quickContact: 'تواصل سريع',
      closeMenu: 'إغلاق قائمة التواصل',
      openMenu: 'فتح قائمة التواصل',
      close: 'إغلاق',
      whatsapp: 'واتساب',
      call: 'اتصال',
      facebook: 'فيسبوك',
      instagram: 'إنستغرام',
      email: 'البريد',
    },
    address: {
      area: 'الاباصيرى، بنى سويف',
      street: 'شارع شانيل، خلف شارع عبدالسلام عارف، بجوار معرض دونا دوني',
    },
    whatsapp: {
      greeting: 'مرحباً! أود معرفة المزيد عن منتجات ليثيو للعطور.',
      cartIntro: 'مرحباً! أود تقديم طلب من ليثيو للعطور:',
      singleIntro: 'مرحباً! أود الطلب من ليثيو للعطور:',
      product: 'المنتج',
      brand: 'العلامة',
      size: 'الحجم',
      price: 'السعر',
      category: 'الفئة',
      total: 'الإجمالي',
      notes: 'ملاحظات',
      thankYou: 'شكراً لك!',
      confirmDelivery: 'يرجى تأكيد التوفر والتوصيل. شكراً!',
    },
    a11y: {
      languageAr: 'العربية',
      languageEn: 'English',
      switchLanguage: 'تغيير اللغة',
      toggleTheme: 'تبديل الوضع',
      productSections: 'أقسام المنتجات',
      shoppingCart: 'سلة التسوق',
      toggleMenu: 'فتح القائمة',
      closeMenu: 'إغلاق القائمة',
      mobileProducts: 'فتح قائمة المنتجات',
      mobileSearch: 'البحث عن المنتجات',
      mobileWishlist: 'فتح المفضلة',
      mobileCart: 'فتح السلة',
      bottleSize: 'حجم الزجاجة',
      hero: 'البانر',
      prevSlide: 'الشريحة السابقة',
      nextSlide: 'الشريحة التالية',
      prevPage: 'الصفحة السابقة',
      nextPage: 'الصفحة التالية',
    },
  },
};
